import React, { useState } from 'react'
import { MaterialReactTable } from 'material-react-table'
import {
  Select,
  MenuItem,
  CircularProgress,
  IconButton,
  Typography,
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { dateToLocal } from '@auteco/utils/dateToLocal'

const GestionTable = ({
  eventosGestion,
  myRol,
  handleEstadoChange,
  handleCheckClick,
  loadingRow,
  loadingRows,
  rowSelection,
  setRowSelection,
  onEditingRowSave,
}) => {
  const columnsGestion = [
    {
      accessorKey: 'reintentos',
      header: 'Reintentos',
      size: 120,
    },
    { 
      accessorKey: 'msg', 
      header: 'Mensaje', 
      size: 300,
    },
    {
      accessorKey: 'documento_ventas',
      header: 'Documento',
      size: 100,
    },
    {
      accessorKey: 'gestion',
      header: 'Fecha límite',
      size: 100,
      Cell: ({ row }) => {
        const value = row.original.gestion
        return value !== null ? dateToLocal(value).formattedDateAndHour : null
      },
      Edit: ({ cell, column, row }) => {
        const [value, setValue] = useState(
          cell.getValue() ? new Date(cell.getValue()) : null
        )
        
        return (
          <DatePicker
            selected={value}
            onChange={(date) => {
              setValue(date)
              row.setValue(column.id, date ? date.getTime() : null)
            }}
            showTimeSelect
            dateFormat="Pp"
            timeFormat="HH:mm"
            minDate={new Date()}
            className="form-control"
          />
        )
      },
    },
    {
      accessorKey: 'estado',
      header: 'Estado',
      size: 150,
      Cell: ({ row }) => {
        const rowData = row.original
        return myRol?.id === 2 ? (
          <Select
            value={rowData.estado}
            onChange={(event) => handleEstadoChange(event, rowData)}
            displayEmpty
          >
            <MenuItem value="PENDIENTE" disabled>
              PENDIENTE
            </MenuItem>
            <MenuItem value="LIBERADO">LIBERADO</MenuItem>
            <MenuItem value="BLOQUEADO_PAGO">BLOQUEADO_PAGO</MenuItem>
          </Select>
        ) : (
          rowData.estado
        )
      },
    },
    ...(myRol?.id !== 2
      ? [
          {
            accessorKey: 'actions',
            header: 'Gestionar',
            size: 100,
            Cell: ({ row }) => {
              const rowData = row.original
              const isRowLoading =
                loadingRow &&
                loadingRow.proceso_id === rowData.proceso_id &&
                loadingRow.gestion === rowData.gestion &&
                loadingRow.reintentos === rowData.reintentos &&
                loadingRow.msg === rowData.msg
              const isMultiLoading =
                loadingRows &&
                loadingRows.some(
                  (r) =>
                    r.proceso_id === rowData.proceso_id &&
                    r.gestion === rowData.gestion &&
                    r.reintentos === rowData.reintentos &&
                    r.msg === rowData.msg
                )
              return (
                rowData.estado === 'PENDIENTE' && (
                  isRowLoading || isMultiLoading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <IconButton onClick={() => handleCheckClick(rowData)}>
                      <CheckIcon style={{ color: 'green' }} />
                    </IconButton>
                  )
                )
              )
            },
          },
        ]
      : []),
  ]

  return (
    <MaterialReactTable
      columns={columnsGestion}
      data={eventosGestion}
      enableRowSelection
      onRowSelectionChange={setRowSelection}
      state={{ rowSelection }}
      enableEditing={false}
      editingMode="row"
      onEditingRowSave={onEditingRowSave}
      muiTableProps={{
        sx: {
          tableLayout: 'fixed',
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: '#F6F6F6',
          color: '#161615',
          fontSize: '14px',
          fontWeight: 700,
          textAlign: 'center',
        },
      }}
      muiTableBodyRowProps={({ row }) => ({
        sx: { 
          '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
          // Deshabilitar la fila si está gestionada
          opacity: row.original.estado === 'GESTIONADO' ? 0.6 : 1,
        },
      })}
      muiTableBodyCellProps={({ row }) => ({
        sx: {
          // Ocultar el checkbox de selección para filas gestionadas
          '& .MuiCheckbox-root': {
            display: row.original.estado === 'GESTIONADO' ? 'none' : 'flex',
          },
        },
      })}
      initialState={{
        pagination: { pageSize: 20, pageIndex: 0 },
      }}
      muiTablePaginationProps={{
        rowsPerPageOptions: [20, 50, 100],
      }}
      renderTopToolbarCustomActions={() => (
        <Typography variant="h6" sx={{ p: 2 }}>
          Gestión de Eventos
        </Typography>
      )}
    />
  )
}

export default GestionTable 